import fetcher from '../modules/ajio-fetch';
import {
  FETCH_AVERAGE_RATING_DATA,
  FETCH_USER_RATING_DATA,
  FETCH_USER_UNRATED_DATA,
  USER_GIVEN_RATING,
  ALL_RATED_PRODUCTS,
  USER_FEEDBACK,
  FETCH_ALL_QUESTIONS
} from '../constants/ratingsConstants';
import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode,
  errorParser,
  tokenReCreateParser
} from '../modules/ajio-fetch/utils';
import { showLoader, hideLoader } from './shared/loader';

// function averageRating(data = {}) {
//     return {
//         type: FETCH_AVERAGE_RATING_DATA,
//         data
//     }
// }

// function userRating(data = {}) {
//     return {
//         type: FETCH_USER_RATING_DATA,
//         data
//     }
// }

export function unratedRating(data = {}) {
  return {
    type: FETCH_USER_UNRATED_DATA,
    data
  };
}

function userFeedbackResponse(data = {}) {
  return {
    type: USER_FEEDBACK,
    data
  };
}

function userGivenRating(data = {}) {
  return {
    type: USER_GIVEN_RATING,
    data
  };
}

function questions(data = {}) {
  return {
    type: FETCH_ALL_QUESTIONS,
    data
  };
}

// function allRatingsByUser(data = {}) {
//     return {
//         type: ALL_RATED_PRODUCTS,
//         data
//     }
// }

// function ratingsAPI(data = {}, productId = '') {
//     const apiEndpoint = `/api/ratings/averageRating/productID=${productId}`;
//     return fetcher(
//         apiEndpoint,
//         fetchGetJSONReqOpts({
//           method: 'GET',
//           headers: {
//             Accept: 'application/json, text/plain, */*',
//             'Content-Type': 'application/json'
//           }
//         })
//     ).then(fetchGetJSONResHandler);
// }

// function userRatingAPI(data = {}) {
//     const {productID = ''} = data;
//     const apiEndpoint = `/api/ratings/userRating/productID=${productID}`;
//     return fetcher(
//         apiEndpoint,
//         fetchGetJSONReqOpts({
//             method: 'GET'
//         })
//     ).then(fetchGetJSONResHandler);
// }

function unratedRatingsAPI(data = {}) {
  const apiEndpoint = `/api/ratings/unratedItems/user`;
  return fetcher(
    apiEndpoint,
    fetchGetJSONReqOpts({
      method: 'GET'
    })
  ).then(fetchGetJSONResHandler);
}

function sendUserRating(data = {}) {
  const apiEndpoint = `/api/ratings/user`;
  const body = data;
  return fetcher(
    apiEndpoint,
    fetchGetJSONReqOpts({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body),
      credentials: 'include'
    })
  ).then(fetchGetJSONResHandler);
}

function ratingQuestions(data = {}) {
  const { categoryID = '' } = data;
  const apiEndpoint = `/api/ratings/getQuestions/${categoryID}`;
  return fetcher(apiEndpoint, fetchGetJSONReqOpts({ method: 'GET' })).then(fetchGetJSONResHandler);
}

function userFeedback(data = {}) {
  const apiEndPoint = '/api/ratings/submitFeedback';
  return fetcher(
    apiEndPoint,
    fetchGetJSONReqOpts({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
  ).then(fetchGetJSONResHandler);
}

// function fetchAllProductsRatings(data = {}) {
//     const apiEndpoint = '/api/ratings//getUserRatings';
//     return fetcher(
//         apiEndpoint,
//         fetchGetJSONReqOpts({method: 'GET'})
//     ).then(fetchGetJSONResHandler)
// }

export function fetchUnratedRatingProducts(reqObj = {}) {
  return dispatch => {
    return unratedRatingsAPI(reqObj)
      .then(resp => {
        dispatch(unratedRating(resp?.response));
        return Promise.resolve(resp);
      })
      .catch(err => {
        return Promise.reject(err);
      });
  };
}

export function fetchUserFeedback(reqObj = {}) {
  return dispatch => {
    dispatch(showLoader('ratings-reviews'));
    return userFeedback(reqObj)
      .then(resp => {
        dispatch(userFeedbackResponse(resp?.response));
        dispatch(hideLoader('ratings-reviews'));
        return Promise.resolve(resp);
      })
      .catch(err => {
        console.log('Error from feedback API', err);
        dispatch(hideLoader('ratings-reviews'));
        return Promise.reject(err);
      });
  };
}

// export function fetchUserRating(reqObj = {}) {
//     return dispatch => {
//         return userRatingAPI(reqObj)
//         .then(response => {
//             dispatch(userRating(response));
//             return Promise.resolve(response);
//         })
//         .catch(error => {
//             console.log('Error from fetch user rating api', error);
//         })
//     }
// }

// export function fetchAvgRating(reqObj = {}, productId = '') {
//     return dispatch => {
//         return ratingsAPI(reqObj, productId)
//         .then(response => {
//             dispatch(averageRating(response));
//             // return Promise.resolve(response)
//         })
//         .catch(error => {
//             console.log('Error from average ratings api', error);
//         })
//     }
// }

export function fetchRatingByUser(reqObj = {}) {
  return dispatch => {
    dispatch(showLoader('ratings-reviews'));
    return sendUserRating(reqObj)
      .then(response => {
        dispatch(userGivenRating(response?.response));
        dispatch(hideLoader('ratings-reviews'));
        return Promise.resolve(response);
      })
      .catch(error => {
        console.log('Error from user given rating API', error);
        dispatch(hideLoader('ratings-reviews'));
        return Promise.reject(error);
      });
  };
}

export function fetchQuestions(reqObj = {}) {
  return dispatch => {
    dispatch(showLoader('ratings-reviews'));
    return ratingQuestions(reqObj)
      .then(response => {
        dispatch(questions(response?.response));
        dispatch(hideLoader('ratings-reviews'));
        return Promise.resolve(response);
      })
      .catch(error => {
        console.log('Error from fetchQuestions API', error);
        dispatch(hideLoader('ratings-reviews'));
        return Promise.reject(error);
      });
  };
}

function submitPhoto(reqObj = {}) {
  const apiEndPoint = '/api/ratings/submitImages';
  return fetcher(
    apiEndPoint,
    fetchGetJSONReqOpts({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(reqObj)
    })
  ).then(fetchGetJSONResHandler);
}

export function submitPhotoReview(reqObj = {}, showLoading = true) {
  return dispatch => {
    if (showLoading) {
      dispatch(showLoader('ratings-reviews'));
    }
    return submitPhoto(reqObj)
      .then(resp => {
        dispatch(hideLoader('ratings-reviews'));
        return Promise.resolve(resp);
      })
      .catch(err => {
        dispatch(hideLoader('ratings-reviews'));
        return Promise.reject(err);
      });
  };
}

function deleteImage(reqObj = {}) {
  const apiEndPoint = '/api/ratings/deleteImage';
  return fetcher(
    apiEndPoint,
    fetchGetJSONReqOpts({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(reqObj)
    })
  ).then(fetchGetJSONResHandler);
}

export function deleteImageReview(reqObj = {}) {
  return dispatch => {
    // dispatch(showLoader('ratings-reviews'))
    return deleteImage(reqObj)
      .then(resp => {
        // dispatch(userFeedbackResponse(resp?.response))
        // dispatch(hideLoader('ratings-reviews'))
        return Promise.resolve(resp);
      })
      .catch(err => {
        console.log('Error from feedback API', err);
        // dispatch(hideLoader('ratings-reviews'))
        return Promise.reject(err);
      });
  };
}

function getAllReviewsApi(reqObj = {}) {
  const apiEndPoint = '/api/ratings/allReviews';
  return fetcher(
    apiEndPoint,
    fetchGetJSONReqOpts({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(reqObj)
    })
  ).then(fetchGetJSONResHandler);
}

export function getAllReviews(reqObj = {}) {
  return dispatch => {
    return getAllReviewsApi(reqObj)
      .then(resp => {
        return Promise.resolve(resp);
      })
      .catch(err => {
        return Promise.reject(err);
      });
  };
}

function markAsHelpful(data = {}) {
  const { reviewId = '' } = data;
  const apiEndPoint = `/api/ratings/markAsHelpful/${reviewId}`;
  return fetcher(
    apiEndPoint,
    fetchGetJSONReqOpts({
      method: 'POST',
      headers: {
        'Content-type': 'application/json'
      }
    })
  ).then(fetchGetJSONResHandler);
}

export function fetchMarkAsHelpful(reqObj = {}) {
  return dispatch => {
    return markAsHelpful(reqObj)
      .then(resp => {
        return Promise.resolve(resp);
      })
      .catch(err => {
        return Promise.reject(err);
      });
  };
}
